import { useEffect } from "react";

import { useSidebarState, useSidebarDispatch } from "contexts/sidebar";

const useAutoCollapse = () => {
  const { isExpanded } = useSidebarState();
  const sidebarDispatch = useSidebarDispatch();

  useEffect(() => {
    isExpanded && sidebarDispatch({ type: "TOGGLE_SIDEBAR" });
  }, []);
};

export default useAutoCollapse;
